import { styled } from 'styled-components';

export const PinContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.grey30_1};
  border-radius: 8px;
`;
